export default {
  mounted() {
    if (this.author) {
      this.$eventBus.$emit('isClientPage', {
        status: this.author?.isClient,
        author: this.author,
      })
    } else {
      this.$eventBus.$emit('isClientPage', {
        status: false,
        author: null,
      })
    }
  },
}
